import HTTP from '../HTTP';

export default {
    getCompanies() {
        // if (userId) {
        //     return HTTP.get('/companies', {
        //         params: {
        //             user_id: userId
        //         }
        //     });
        // }
        return HTTP.get('/companies');
    },
    createCompany(data) {
        return HTTP.post('/companies', data);
    },
    attachUser(data) {
        const { company_id, user_id } = data;
        return HTTP.put(`/companies/${company_id}/attach`, { user_id });
    },
    unattachUser(data) {
        const { company_id, user_id } = data;
        return HTTP.delete(`/companies/${company_id}/attach`, { data: { user_id } });
    },
    updateCompany(data) {
        const { id } = data;
        return HTTP.put(`/companies/${id}`, data);
    },
    getCompanyFirstUser(companyId) {
        return HTTP.get(`/companies/${companyId}/first-user`);
    },
    listWithFirstUser() {
        return HTTP.get('/companies/list-with-first-user');
    }
};